/** Single source for the product name so it can be swapped without a code hunt. */
export const BRAND = {
  name: 'CrowdSet',
  tagline: 'Take turns. Play the room.',
  reactionLabel: 'CrowdSet reactions',
} as const;

export const PROTOCOL_VERSION = 1 as const;
